import { Box, Grid, Typography } from '@mui/material';
import { isValidKey } from '../../../../../shared/utils/validKey';
import { getQuestions } from '../../pqr_web/survey/formData';
import { useSurveyDetail } from './hook';
import { LayoutModule } from '../../../../layout/modules';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { PQR_DETAIL } from '../../../../../routes/paths';
import dayjs from 'dayjs';

export const PqrSurveyDetail = () => {
    const { formik, halfName, pqr } = useSurveyDetail();
    console.log(formik);
    if (!halfName) return null;

    const questions = getQuestions(halfName)?.questions || [];

    return (
        <LayoutModule
            title="Detalle encuesta atención PQR"
            withAccordion={false}
            additionalButtons={
                <ActionButtonGroup
                    id={pqr?.id || ''}
                    buttonView={{
                        show: true,
                        route: PQR_DETAIL,
                    }}
                />
            }
        >
            <Grid container spacing={2} px={{ xs: 2, md: 6 }} display="flex">
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Box
                                p={2}
                                borderRadius={2}
                                sx={{
                                    backgroundColor: '#EDE7F6',
                                    color: '#000000',
                                }}
                            >
                                <Typography
                                    fontFamily="Lucida Sans"
                                    fontSize="1.2rem"
                                    fontWeight="700"
                                    textAlign="center"
                                    mb={1}
                                >
                                    PRD id:
                                </Typography>
                                <Typography
                                    fontFamily="Lucida Sans"
                                    fontSize="1.2rem"
                                    fontWeight="700"
                                    textAlign="center"
                                >
                                    {pqr?.consecutiveFormat}
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Box
                                p={2}
                                borderRadius={2}
                                sx={{
                                    backgroundColor: '#EDE7F6',
                                    color: '#000000',
                                }}
                            >
                                <Typography
                                    fontFamily="Lucida Sans"
                                    fontSize="1.2rem"
                                    fontWeight="700"
                                    textAlign="center"
                                    mb={1}
                                >
                                    Fecha de diligenciamiento:
                                </Typography>
                                <Typography
                                    fontFamily="Lucida Sans"
                                    fontSize="1.2rem"
                                    fontWeight="700"
                                    textAlign="center"
                                >
                                    {dayjs(pqr?.survey?.created_at)
                                        .subtract(5, 'hours')
                                        .format('DD-MM-YYYY HH:mm:ss')}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
                {questions.map((question) => {
                    const value =
                        formik.values[
                            question.id as keyof typeof formik.values
                        ];
                    if (typeof value !== 'string' || value.trim() === '')
                        return null;

                    return (
                        <Grid item xs={12} key={question.id}>
                            <Box
                                mb={2}
                                p={2}
                                borderRadius={2}
                                sx={{
                                    backgroundColor: '#EDE7F6',
                                    color: '#000000',
                                }}
                            >
                                <Typography
                                    fontFamily="Lucida Sans"
                                    fontSize="1.2rem"
                                    fontWeight="700"
                                    textAlign="center"
                                    mb={1}
                                >
                                    {question.text} <span>*</span>
                                </Typography>
                                <Typography
                                    fontFamily="Lucida Sans"
                                    fontSize="1.2rem"
                                    fontWeight="700"
                                    textAlign="center"
                                >
                                    {isValidKey(question.id, formik.values)
                                        ? value
                                        : 'No disponible'}
                                </Typography>
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>
        </LayoutModule>
    );
};
